import { constants } from 'modules/common';
import { z } from 'zod';

const { qBooksConstants } = constants;

export const createSchema = (isRequiredLocation: boolean) => {
    return z.object({
        date: z.string(),
        department: z.string().min(Number(isRequiredLocation)),
        shipTo: z.string(),
        shipVia: z.string().max(qBooksConstants.SHIPPING_METHOD_MAX_LENGTH),
        shippingAddress: z.string().max(qBooksConstants.SHIPPING_ADDRESS_MAX_LENGTH),
        customFields: z.record(z.string()),
    });
};
